import React from 'react';
import Card from '../../components/ui/Card/Card';
import Skeleton from '../../components/ui/Skeleton/Skeleton';
import styles from './Clients.module.css';

const ClientsSkeleton: React.FC = () => (
  <div className={styles.page}>
    <Card className={styles.headerBar}>
      <Skeleton width={160} height={28} />
      <div className={styles.headerActions}>
        <Skeleton width={130} height={40} className={styles.skRounded} />
        <div className={styles.search}>
          <Skeleton width="100%" height={44} className={styles.skRounded} />
        </div>
      </div>
    </Card>

    <div className={styles.grid}>
      {Array.from({ length: 8 }).map((_, i) => (
        <Card key={i} className={styles.clientCard}>
          <Skeleton width="80%" height={18} />
          <div className={styles.stats}>
            <Skeleton width={70} height={12} />
            <Skeleton width={70} height={12} />
            <Skeleton width={80} height={12} />
          </div>
          <div className={styles.cardFoot}>
            <Skeleton width={60} height={14} />
            <Skeleton width={90} height={30} className={styles.skRounded} />
          </div>
        </Card>
      ))}
    </div>
  </div>
);

export default ClientsSkeleton;
